import { useMutation } from "@apollo/client/react";
import {
    createContext,
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    useCallback,
    useRef,
    useState,
} from 'react';
import { ReachLinkSessionEventLog } from 'src/@types/shared.types';
import { LOG_SESSION_EVENTS } from 'src/graphql/resolvers/mutations';
import { useDebounceCallback, useInterval } from 'usehooks-ts';
import { ReachLinkSessionEventType } from '../enums/shared.enums';

const BATCH_INTERVAL = 30000;

interface IVideoCallLogContext {
    logSessionEvent: (event: Omit<ReachLinkSessionEventLog, 'time'>, critical?: boolean) => void;
    setAppointmentId: Dispatch<SetStateAction<number | null>>;
}

export const VideoCallLogContext = createContext<IVideoCallLogContext | undefined>(undefined);

export const VideoCallLogProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [appointmentId, setAppointmentId] = useState<number | null>(null);

    const bufferRef = useRef<ReachLinkSessionEventLog[]>([]);

    const [logSessionEventsMutation] = useMutation(LOG_SESSION_EVENTS, {
        onCompleted: () => {
            bufferRef.current = [];
        },
        onError: (error) => {
            console.log(error);
        },
    });

    const sendBufferedEvents = useCallback(() => {
        if (bufferRef.current.length > 0)
            logSessionEventsMutation({
                variables: { appointmentId, sessionEvents: bufferRef.current },
            });
    }, [appointmentId, logSessionEventsMutation]);

    const debouncedSendBufferedEvents = useDebounceCallback(sendBufferedEvents, 500);

    const logSessionEvent = useCallback(
        (event: Omit<ReachLinkSessionEventLog, 'time'>, critical?: boolean) => {
            // Disabled
            // const fullEvent: ReachLinkSessionEventLog = {
            //     ...event,
            //     metadata: JSON.stringify(event.metadata),
            //     time: new Date().toISOString(),
            // };
            // if (critical) {
            //     logSessionEventsMutation({
            //         variables: { appointmentId, sessionEvents: [fullEvent] },
            //     });
            // } else {
            //     bufferRef.current.push(fullEvent);
            //     if (event.type === ReachLinkSessionEventType.USER_LEFT)
            //         debouncedSendBufferedEvents();
            // }
        },
        [appointmentId, logSessionEventsMutation, debouncedSendBufferedEvents]
    );

    // useInterval(() => {
    //     debouncedSendBufferedEvents();
    // }, BATCH_INTERVAL);

    return (
        <VideoCallLogContext.Provider
            value={{
                setAppointmentId,
                logSessionEvent,
            }}
        >
            {children}
        </VideoCallLogContext.Provider>
    );
};
